import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import {
  analyticsPath,
  cartPath,
  rootPath,
  seriesDetailPath,
  orderDashboardPath,
  announcementsPath,
  submissionSuccessPath,
  submissionFailurePath,
  userSettingPath,
} from 'utils/paths';

import Layout from '../Layout/Root';
import Cart from '../Cart/Root';
import SubmissionSuccess from '../SubmissionSuccess/Root';
import SubmissionFailure from '../SubmissionFailure/Root';
import Analytics from '../Analytics/Root';
import OrderDashboard from '../OrderDashboard/Root';
import SeriesDetail from '../SeriesDetail/Root';
import SeriesDetailNav from '../SeriesDetailNav/Root';
import Announcement from '../Announcement';
import UserSetting from '../UserSetting/Root';
import IdpResponseHandler from '../../utils/IdpResponseHandler';
import { AUTH_URL,CLIENT_ID ,REDIRECT_URI,SCOPE,NONCE} from 'constants/values';

import './styles.module.scss';

class App extends Component {
  constructor(props) {
    super(props);
    this.loginWithOIDC = this.loginWithOIDC.bind(this);
  }
  componentDidMount() {
    const accessToken = sessionStorage.getItem('access_token');
    const idToken = sessionStorage.getItem('id_token');
    const currentPath = window.location.pathname;
    // If user has no tokens and not at IDP callback path
    if (!accessToken || !idToken) {
      if (!currentPath.includes('/oauth2/idpresponse')) {
        sessionStorage.setItem('login', '[AUTH] No tokens, redirecting to ');
        this.loginWithOIDC(); // triggers login
      }
    }
  }

  loginWithOIDC () {
    const params = new URLSearchParams({
      response_type: 'token id_token',
      client_id: CLIENT_ID,
      redirect_uri: REDIRECT_URI,
      scope: SCOPE,
      nonce: NONCE,
      acr_values:'strongAuth4000Service'
    });

    window.location.href = `${AUTH_URL}?${params.toString()}`;
  };

  render() {
    return (
      <Layout>
        <Route path="/oauth2/idpresponse" component={IdpResponseHandler} />
        <Route exact path={rootPath} component={OrderDashboard} />
        <Route path={submissionSuccessPath} component={SubmissionSuccess} />
        <Route path={submissionFailurePath} component={SubmissionFailure} />
        <Route path={cartPath} component={Cart} />
        <Route path={analyticsPath} component={Analytics} />
        <Route path={seriesDetailPath} component={SeriesDetailNav} />
        <Route path={seriesDetailPath} component={SeriesDetail} />
        <Route path={orderDashboardPath} component={OrderDashboard} />
        <Route path={userSettingPath} component={UserSetting} />
        <Route exact path={announcementsPath} component={Announcement} />
      </Layout>
    );
  }
}

export default App;
